const pais = {
  path: "/pais",
  redirect: "/pais",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "/pais/novo",
      name: "pais_novo",
      meta: {
        requireAuth: false,
      },
      component: () => import("@/views/Pais/PaisCad.vue"),
    },
    {
      path: "/pais/edit/:id",
      name: "pais_atualizar",
      meta: {
        requireAuth: false,
      },
      component: () => import("@/views/Pais/PaisEdit.vue"),
    },
    {
      path: "/pais",
      name: "pais",
      meta: {
        requireAuth: false,
      },
      component: () => import("@/views/Pais/PaisHome.vue"),
    },
  ],
};

export { pais };
